"use strict";
const _ = require('lodash');
/*
 This would be awesome to describe on the domain model
 i.e. orderNumber on order.json is a keyword (or a better name)
 in addition to that we could add common integration names for orderNumber, order_id_fx springs to mind
 If they can be generated as well by specifying a keyword for an integration that would be awesome

 Finally, we're missing a generator in clay to generate a file that is shared across domains
 i.e. a file that is generated from domain model files across services (orders,articles, integration, suppliercustomers )
*/
const keys = [
    'action',
    // keys from hicore',
    'Item.Number',
    'ItemNumber',
    'Number',
    'SerialNumber',
    // keys from our domain model
    'name',
    'orderNumber',
    'customerNumber',
    'invoiceNumber',
    'articleNumber',
    'subdomain',
    'title',
    'email',
    'id',
    'systembolagetArticleNumber',
    // keys from fx types
    'cust_id',
    'art_id',
    'order_id_fx',
    'order_id_supp',
    'supp_id',
    'art_name',
    // keys from brighcom types
    'sku',
    'flaivyOrderId',
    'bcOrderId',
    'partNo',
    'priceListCode',
    'priceListName',
    // keys from extend
    'OrderNumber',
    'InvoiceNumber',
    'ExternalOrderNumber',
    'CustomerNumber',
    'ProductNumber',
];
const keysToOmit = ['owningSupplierOrganizationId', 'metadata'];
module.exports = entity => {
    if (!entity) {
        return '';
    }
    const metadata = _.get(entity, 'metadata', {}) || {};
    const target = _.omit(_.get(entity, 'target', {}), keysToOmit);
    const targetMetadata = _.get(entity, 'target.metadata', {}) || {};
    return _.uniq([
        ...Object.values(target),
        ...Object.values(targetMetadata),
        ...Object.values(metadata),
        ...keys.map(key => _.get(entity, key)),
    ].filter(x => x && !_.includes(keysToOmit, x)))
        .join(' ')
        .substring(0, 254)
        .trim();
};
